import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const testimonials = [
  {
    name: "Ananya",
    age: "24",
    occupation: "Software Engineer",
    text: "Switching to Organic Pads was the best decision for my health. They feel so soft, are free from chemicals, and keep me comfortable even on long workdays.",
  },
  {
    name: "Meera",
    age: "30",
    occupation: "Yoga Instructor",
    text: "Finally, a pad that aligns with my eco-conscious lifestyle! Organic Pads are gentle on the skin and completely biodegradable. I love that I’m reducing waste while staying worry-free.",
  },
  {
    name: "Simran",
    age: "21",
    occupation: "College Student",
    text: "No rashes, no irritation—just pure comfort! I never realized how much synthetic pads were affecting me until I made the switch to Organic Pads.",
  },
  {
    name: "Priya",
    age: "38",
    occupation: "Entrepreneur",
    text: "I have a sensitive skin condition, and these organic pads have made a huge difference. No more itching or discomfort. Highly recommend!",
  },
  {
    name: "Aditi",
    age: "27",
    occupation: "Doctor",
    text: "As a medical professional, I know the importance of using toxin-free products. Organic Pads give me peace of mind knowing that I'm using something safe and natural.",
  },
  {
    name: "Rhea",
    age: "35",
    occupation: "Teacher",
    text: "I was hesitant to try organic pads, but now I can't imagine going back. They are ultra-absorbent, breathable, and so much better for the environment.",
  },
];

export default function TestimonialSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="flex flex-col items-center w-full py-8">
      <h2 className="text-3xl font-extrabold mb-6">TESTIMONIALS</h2>

      <div className="relative flex items-center justify-center w-full max-w-4xl">
        {/* Left Button */}
        <button
          onClick={prevSlide}
          className="absolute left-[-40px] p-2 bg-gray-200 rounded-full shadow-md hover:bg-gray-300 transition hidden md:flex"
        >
          <ChevronLeft size={24} />
        </button>

        {/* Testimonial Cards */}
        <div className="flex overflow-hidden w-full max-w-5x px-2">
            {testimonials.map((testimonial, index) => (
                <div
                key={index}
                className={`w-full md:w-1/3 transition-transform m-2 duration-300 ease-in-out transform ${
                    index >= currentIndex && index < currentIndex + 3 ? "block" : "hidden"
                } flex-shrink-0 bg-white p-6 rounded-2xl shadow-lg text-center border`}
                >
              <h3 className="text-xl font-bold">{testimonial.name}</h3>
              <p className="text-gray-500 text-sm">{testimonial.age} / {testimonial.occupation}</p>
              <p className="mt-3 text-gray-700 text-sm leading-relaxed">{testimonial.text}</p>
            </div>
          ))}
        </div>

        {/* Right Button */}
        <button
          onClick={nextSlide}
          className="absolute right-[-40px] p-2 bg-gray-200 rounded-full shadow-md hover:bg-gray-300 transition hidden md:flex"
        >
          <ChevronRight size={24} />
        </button>
      </div>
    </div>
  );
}
